
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Subject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DMSDefaultValuesViewModel, DMSNameDetails, TableNameDetails } from '../../../business-entities/dms-defaultvalues-view-model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { DMSDefaultValuesService } from '../../../business-services/dms-defaultvalues.service';
import { AddDmsValuesComponent } from '../add-dms-values/add-dms-values.component';

@Component({
  selector: 'app-dms-values',
  templateUrl: './dms-values.component.html',
  styleUrls: ['./dms-values.component.css']
})
export class DmsValuesComponent implements OnInit {

  DMSDefaultList: DMSDefaultValuesViewModel[] = [];
  DMSDefaultValues: DMSDefaultValuesViewModel[];
  popupCloseResult = false;
  paginationSub: Subscription;
  focus$ = new Subject<string>();
  userRoleRightsDetails: UserRoleMenu;
  enableEdit = false;
  enableEditIndex = null;
  dmsNameList: DMSNameDetails[];
  tableNameList:TableNameDetails[];
  tableNames: TableNameDetails[];
  selectedDMSName:string;
  selectedTableName: string;
  DMSValueListRequest: any = {};
  throttle = 100;
  scrollDistance = 1;
  totalCount: number = 0;
  searchTerm = '';

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private dmsDefaultValuesService: DMSDefaultValuesService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private userService: UserDataService,
    private config: NgbModalConfig,
    private toaster: ToastrService
  ) {

    config.backdrop = 'static';
    config.keyboard = false;
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.DMSValueListRequest.sortColumn = column;
    this.DMSValueListRequest.sortDirection = direction;
  }
  ngOnInit(): void {
    this.selectedDMSName = null;
    this.selectedTableName = null;
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.DMSDefaultValues);

    this.DMSValueListRequest = {
      selectedDMSName :'',
      selectedTableName :'',
      searchTerm: '',
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
    }
    this.getDMSDefaultValuesList();
    this.GetDMSName();
    this.GetTableName();
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.DMSDefaultList.length){
      this.DMSValueListRequest.startRecordNumber = this.DMSDefaultList.length;
      this.getDMSDefaultValuesList();
    }

  }
  getDMSDefaultValuesList() {
    this.spinner.show();
      this.dmsDefaultValuesService.getDMSDefaultValues(this.DMSValueListRequest).then(response => {
        if (response) {
          this.totalCount = 0
          this.DMSDefaultList.push(...this.DMSValuesDataMapper(response));
          if(this.DMSDefaultList.length > 0)
            this.totalCount = this.DMSDefaultList[0].totalCount;
          this.spinner.hide();
        } else if (
          response.responseObject &&
          response.responseObject.errorCount > 0
        ) {
          if (
            response.responseObject.result &&
            response.responseObject.result.errorCode ===
            Enums.ErrorCodes.ServiceCategoriesCode
          ) {
            this.spinner.hide();
          }
        }
        this.spinner.hide();
      })
   .catch(()=>{
    this.spinner.hide();
  })
  }
  private DMSValuesDataMapper(DMSDefaultList: any) {
    let supperArray = [];
    if (DMSDefaultList && DMSDefaultList.length > 0) {
      for (let index = 0; index < DMSDefaultList.length; index++) {
        const element = DMSDefaultList[index];

        let single = Object();
        single.RowId = this.DMSValueListRequest.startRecordNumber + 1 + index ;
        single.id = element.rowId;
        single.DMSName = element.dmsName;
        single.TableName = element.tableName;
        single.DMSColumnName = element.dmsColumnName;
        single.DMSValues = element.dmsValues;
        single.DMSColumnDataType = element.dmsColumnDataType;
        single.totalCount = element.totalCount;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  GetDMSName() {
    this.spinner.show();
    this.dmsDefaultValuesService.GetDMSName()
      .then((res) => {
        if (res) {
          this.dmsNameList = this.mapDMSName(res);
        }
      })
    this.spinner.hide();
  }
  mapDMSName(List) {
    let supperArray = [];
    if (List && List.length > 0) {
      List.forEach(element=>{
        let single = Object();
        single.id = element.id;
        single.name = element.dmsName
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  GetTableName() {
    this.spinner.show();
    this.dmsDefaultValuesService.GetTableName()
      .then((res) => {
        if (res) {
          this.tableNameList = this.maptableName(res);
        }
      })
    this.spinner.hide();
  }
  maptableName(List) {
    let supperArray = [];
    if (List && List.length > 0) {

      List.forEach(element=>{

        let single = Object();
        single.id = element.id;
        single.name = element.tableName;
        single.dmsName = element.dmsName;
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onSearchFilter(){
    this.DMSValueListRequest.startRecordNumber = 0;
    this.DMSValueListRequest.pageSize = 25;
    this.DMSValueListRequest.searchTerm = this.searchTerm;
    this.DMSDefaultList = [];
    this.getDMSDefaultValuesList();
  }

  DMSNameChange(dmsName : string){
    if(dmsName != null){
      this.tableNames = this.tableNameList;
      this.tableNames = this.tableNames.filter(x => x.dmsName.toUpperCase() === dmsName.toUpperCase())
    }
    else{
      this.tableNames = [];
      this.selectedTableName = null;
    }
  }

  Search(){
    this.DMSValueListRequest.selectedDMSName = this.selectedDMSName;
    this.DMSValueListRequest.selectedTableName = this.selectedTableName;
    this.DMSValueListRequest.startRecordNumber = 0;
    this.DMSValueListRequest.pageSize = 25;
    this.DMSValueListRequest.searchTerm = this.searchTerm;
    this.DMSDefaultList = [];
    this.getDMSDefaultValuesList();
  }

  TableNameChange(_tableName: TableNameDetails)
  {
    // This is intentional
  }

  onAdd() {
    const modalref = this.modalService.open(AddDmsValuesComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }

  enableEditMethod(_e, i) {
    this.enableEdit = true;
    this.enableEditIndex = i;
  }

  cancel(){
    this.enableEdit = false;
    this.enableEditIndex = null;
    this.getDMSDefaultValuesList();
  }

  saveSegment(dmsvalue,_i){
    this.enableEdit=false;
    this.EditDMSDefaultValues(dmsvalue);
  }

  EditDMSDefaultValues(dmsvalue : DMSDefaultValuesViewModel){
    let updatedDefaultValueMessage = this.translate.instant("lblUpdatedDMSDefaultValueMessage");
    let alredayExistDefaultValueMessage = this.translate.instant("lblalredayExistDefaultValueMessage");
    this.spinner.show();
    this.dmsDefaultValuesService.UpdateDMSDefaultValues(dmsvalue).then(res => {
      if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
        this.toaster.success(updatedDefaultValueMessage);
      }
      else if(res.responseCode === Enums.ErrorCodes.AlreadyExist){
      this.toaster.warning(alredayExistDefaultValueMessage);
      this.getDMSDefaultValuesList();
      }
      this.spinner.hide();
    });
  }

  DeleteDefaultDMSValues(dmsvalue,_i) {
    this.spinner.show();
    this.spinner.hide();
    let modelBodymsg = "";
    let modelHeadermsg = this.translate.instant('lblDelete');
    modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblDMSDefaultValues"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      _result => {
        // This is intentional
       },
      reason => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.dmsDefaultValuesService.DeleteDefaultDMSValues(dmsvalue.id).then(response => {
            if (response.responseCode == Constant.SuccessResponseCode) {
              let deletedmsg = this.translate.instant('lblDeletedDefaultDMSValue');
              this.toastr.success(deletedmsg);
              this.getDMSDefaultValuesList();
              this.GetDMSName();
              this.GetTableName();
              this.selectedDMSName = null;
              this.selectedTableName = null;
          }
            else if (response.responseCode == Constant.ValidationFailure) {
              let deletedmsg = this.translate.instant('lblDefaultDMSValueNotDeleted');
              this.toastr.error(deletedmsg);
            }
          });
        }
      }
    );
    this.spinner.hide();
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
}
